// extracted by mini-css-extract-plugin
var _1 = "textBlock__rEg3N";
export { _1 as "textBlock" }
export default { "textBlock": _1 }
